import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/app-store-ios': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM127 384.5C121.5 394.1 109.2 397.3 99.7 391.8 90.1 386.3 86.9 374 92.4 364.5L106.7 339.8C122.8 334.9 136 338.7 146.3 351.2L127 384.5zM265.9 330.6H84C73 330.6 64 321.6 64 310.6S73 290.6 84 290.6H135L200.4 177.4 179.9 142C174.4 132.4 177.7 120.2 187.2 114.7 196.8 109.2 209 112.5 214.5 122L223.4 137.4 232.3 122C237.8 112.4 250.1 109.2 259.6 114.7 269.2 120.2 272.4 132.5 266.9 142L181.1 290.6H243.2C263.4 290.6 274.7 314.3 265.9 330.6zM364 330.6H335L354.6 364.5C360.1 374.1 356.8 386.3 347.3 391.8 337.7 397.3 325.5 394 320 384.5 287.1 327.6 262.5 284.8 246 256.4 229.3 227.4 241.2 198.4 253.1 188.6 266.2 211.3 285.8 245.3 312 290.6H364C375 290.6 384 299.6 384 310.6 384 321.7 375 330.6 364 330.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/app-store-ios.js
// module id = PPth
// module chunks = 144